import { render, staticRenderFns } from "./SuggestPopup.vue?vue&type=template&id=467922b8&scoped=true"
import script from "./SuggestPopup.vue?vue&type=script&lang=js"
export * from "./SuggestPopup.vue?vue&type=script&lang=js"
import style0 from "./SuggestPopup.vue?vue&type=style&index=0&id=467922b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467922b8",
  null
  
)

export default component.exports